<template>
    <div>
      <slot name="cached" /> 
    </div>
</template>
<script>
import { isFunction } from 'lodash';
export default {
  props:{
    container:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    }
  },
  data() {
    return {
      //bounds:this.getBounds()
      bounds:{
        p1:{x:0,y:0},
        p2:{x:1,y:0},
        p3:{x:1,y:1},
        p4:{x:0,y:1},
      }
    }
  },
  mounted() {
    this.renderTools.addToRunBatch( () => {
      this.container.containerUpdateTransform();
      this.renderTools.addToRunBatch( () => {
        if (isFunction(this.container.cacheAsBitmap)) {
          this.container.cacheAsBitmap(true);
        } else {
          console.warn('you passed the wrong thingy');
          this.container.cacheAsBitmap = true;
        }
        this.renderTools.addToRunBatch( () => {
          this.$emit("cached");
          this.container.containerUpdateTransform();
        });
      });
    });
  },
  beforeDestroy() {
    this.renderTools.addToRunBatch( () => {
      if (isFunction(this.container.cacheAsBitmap)) {
        this.container.cacheAsBitmap(false);
      } else {
        console.warn('you passed the wrong thingy');
        this.container.cacheAsBitmap = false;
      }
      this.renderTools.addToRunBatch( () => {
        try {
          this.container.containerUpdateTransform();
        } catch (e) {
          // ignore - could be that user is changing scenes etc.
        }
        this.$emit('uncached');
      });
    });
    //this.renderTools.addToRunBatch( () => {
    //});
  },
  methods: {
    containerUpdateTransform(container) {
      // lol this timeout
      //setTimeout( () => {
        //this.renderTools.addToRunBatch( () => {
        //});
      //}, 0);
    },
  }

}
</script>
